<script lang="ts">
	import { getSetupTwoFactorAuth } from '../../../api/EnzianApi';
	import type { TwoFactorAuthSetup } from '../../../types/LoginTypes';
	import DefaultButton from '../../../basic/buttons/DefaultButton.svelte';
	import type { FlowContainerContext } from '../../../types/FlowContainerTypes';
	import { addNotification } from '../../../notification/Notificationstore';
	import QRCode from 'qrcode';
	import { getContext } from 'svelte';
	import { _ } from 'svelte-i18n';

	interface Props {
		targetLoginId: number;
		twoFactoryActive: boolean;
		onModalClose: () => void;
		deactivateFunction: (targetLoginId: number) => Promise<void>;
	}

	let { targetLoginId, twoFactoryActive, onModalClose, deactivateFunction }: Props = $props();

	let { nextPage } = getContext<FlowContainerContext>('enzianFlowContainer');

	let twoFactorAuthSetup: TwoFactorAuthSetup | null = $state(null);

	async function createQrCode() {
		//Only allow when there is no tow factor auth already
		if (!twoFactoryActive) {
			//Request setup uri from backend
			twoFactorAuthSetup = await getSetupTwoFactorAuth(targetLoginId);

			QRCode.toCanvas(
				document.getElementById('qrcode'),
				twoFactorAuthSetup.setupUri,
				function (error) {
					if (error) {
						addNotification({
							type: 'error',
							message: $_('settings.admin.two_factor_auth.err_qr_code_creation')
						});
					}
				}
			);
		}
	}

	async function handleRemoveTwoFactorAuthCode() {
		if (twoFactoryActive) {
			//We have to deactive it on the login store.
			await deactivateFunction(targetLoginId);
		}
	}
</script>

<div class="">
	<p style="max-width: 550px;">{$_('settings.admin.two_factor_auth.lbl_description')}</p>

	{#if twoFactoryActive == false}
		<!--Canvas for qr code-->
		<div class="flex mt-4 mb-8 flex-col gap-2 items-center">
			<canvas style="height: 180px; width: 180px" id="qrcode"></canvas>
			<p>{twoFactorAuthSetup?.secret || ''}</p>
		</div>

		<p style="max-width: 550px;" class="text-sm text-red dark:text-orange mb-8">
			{$_('settings.admin.two_factor_auth.lbl_warning')}
		</p>
		<div class="flex flex-col md:flex-row justify-end gap-2">
			<!--Close-->
			<DefaultButton
				secondary={true}
				text={$_('general.bt_close')}
				onClick={() => {
					//Hide the modal
					onModalClose();
				}}
			/>
			<!--Start the call to generate a code-->
			<DefaultButton
				disabled={twoFactorAuthSetup != null}
				text={$_('settings.admin.two_factor_auth.bt_generate_code')}
				spamProtectedCall={createQrCode}
			></DefaultButton>
			<!--Netxt button-->
			<DefaultButton
				disabled={twoFactorAuthSetup == null}
				text={$_('settings.admin.two_factor_auth.bt_verify')}
				onClick={() => nextPage()}
			></DefaultButton>
		</div>
	{:else}
		<p class="text-red dark:text-orange my-4">
			{$_('settings.admin.two_factor_auth.lbl_already_setup')}
		</p>
		<div class="flex justify-end gap-2">
			<!--Close-->
			<DefaultButton
				secondary={true}
				text={$_('general.bt_close')}
				onClick={() => {
					//Hide the modal
					onModalClose();
				}}
			/>
			<!--Start the call to generate a code-->
			<DefaultButton
				warning={true}
				text={$_('settings.admin.two_factor_auth.bt_deactivate')}
				spamProtectedCall={handleRemoveTwoFactorAuthCode}
			></DefaultButton>
		</div>
	{/if}
</div>
